import React from 'react';
import styled from '@emotion/styled';
import Link from 'next/link';

import { RATERS, URLS } from '../../constants';
import { ExtraSmall } from '../type';

const StyledLink = styled(Link)`
  text-decoration: underline;
`;

export const tooltipCopy = {
  [RATERS.UCSR]: {
    driverProtection: (
      <ExtraSmall>
        Assesses how well the vehicle protects its driver from being killed or seriously injured in a crash.
      </ExtraSmall>
    ),
    protectionOtherRoadUsers: (
      <ExtraSmall>
        Assesses how well the vehicle protects other drivers, pedestrians, cyclists and motorcyclists from being killed
        or seriously injured in a crash.
      </ExtraSmall>
    ),
    crashAvoidance: (
      <ExtraSmall>
        Assesses the likelihood of being involved in a crash through key crash avoidance technologies being available in
        this model of vehicle. Ensure that the version you are looking at has the most recommended safety features.
      </ExtraSmall>
    ),
  },
  [RATERS.ANCAP]: {
    activeSafetyAssist: (
      <ExtraSmall>
        Evaluates the presence and effectiveness of active safety technologies fitted to the vehicle which assist the
        driver in preventing or reducing the effects of a crash.
      </ExtraSmall>
    ),
    adultOccupantProtection: (
      <ExtraSmall>
        Evaluates the level of protection offered by the vehicle to adult occupants seated in the front and second row
        in the most common types of serious injury crashes.
      </ExtraSmall>
    ),
    childOccupantProtection: (
      <ExtraSmall>
        Evaluates the level of protection the vehicle offers to child occupants seated in appropriate child restraints
        in the rear seats. The ability to accommodate a range of child restraints is also assessed.
      </ExtraSmall>
    ),
    overallScore: (
      <ExtraSmall>
        Overall score represents the overall safety of a vehicle; from 2018 ANCAP stopped reporting the overall score as
        test protocols evolved to evaluating four key areas.{' '}
        <StyledLink href={URLS.RATINGS} target="_blank" rel="noopener noreferrer">
          Find out more
        </StyledLink>
      </ExtraSmall>
    ),
    pedestrianProtection: (
      <ExtraSmall>
        Assesses the design of the front of the vehicle to minimise injury risk to a pedestrian when struck.
      </ExtraSmall>
    ),
    vulnerableRoadUserProtection: (
      <ExtraSmall>
        Assesses whether the design of the front of the vehicle will reduce injury risk to a pedestrian when struck.
        Vehicles are also assessed for their ability to avoid or reduce impacts with pedestrians and cyclists.
      </ExtraSmall>
    ),
    // @TODO: These appear unused. Clarify with TAC if they should be removed.
    crashAvoidance: (
      <ExtraSmall>
        The crash avoidance score takes into account a vehicles design and fitted safety features to determine
        likelihood of the vehicle being involved in a crash.
      </ExtraSmall>
    ),
    protectionOtherRoadUsers: (
      <ExtraSmall>
        The pedestrian protection score takes into account the injury risk posed to other road users in a crash (e.g
        pedestrians and cyclists or occupants of other vehicles).
      </ExtraSmall>
    ),
  },

  recommendedSafetyFeatures: (
    <ExtraSmall>
      These safety features improve the safety of a vehicle, the more of these features a vehicle has, the safer the
      vehicle is.{' '}
      <StyledLink href={URLS.SAFETY_FEATURES_LISTING} target="_blank" rel="noopener noreferrer">
        Learn about the Recommended Safety Features here.
      </StyledLink>
    </ExtraSmall>
  ),
};
